/**
 * 적재 확약 창의 «신고 칸» → 훅 인자. 🔴 **비우면 키를 싣지 않는다.**
 *
 * 근거: 실서버 `LoadConfirmEnvelope`(`command_id` · `confirm_source` · `loaded_chambers?: integer ≥ 0` —
 * 2026-09-29 실측, 이 셋뿐) · 서버 `tray_confirm.py` `LOAD_REPORTED_FIELDS`(「안 받았으면 싣지도 적지도 않는다」).
 *
 * ⚠ **평형추 적재 신고(`counterweight_loaded`)는 계약에서 빠졌다**(2026-09-29). 평형추는 C 트레이 전용 칸에
 *   상주하는 기본 적재다. 서버는 그 키를 422 없이 조용히 버리므로 **보내지 않는다.** 되살리지 마라.
 * 🔴 **`0` 은 신고다.** 빈 칸만 「신고 안 함」이다 — `Number('')` 가 `0` 이라 문자열 그대로 판정한다.
 */

export interface LoadConfirmForm {
  /** 입력 상자의 날 글자. 빈 글자 = 신고 안 함 */
  chambers: string
}

export const EMPTY_LOAD_CONFIRM_FORM: LoadConfirmForm = {
  chambers: '',
}

/** 훅(`useConfirmLoad`)이 받는 신고 칸. 키가 없으면 본문에도 없다 */
export interface LoadConfirmReport {
  loadedChambers?: number
}

/** 0 이상의 정수 글자만 받는다(계약 `minimum: 0` · `integer`). 앞뒤 공백은 봐준다 */
const NON_NEGATIVE_INT = /^\d+$/

/** 챔버 수 글자가 규칙을 어겼나. 빈 글자는 위반이 아니다(신고 안 함) */
export function chambersInvalid(text: string): boolean {
  const trimmed = text.trim()
  return (
    trimmed !== '' && (!NON_NEGATIVE_INT.test(trimmed) || !Number.isSafeInteger(Number(trimmed)))
  )
}

/**
 * 폼 → 신고. 챔버 수가 규칙을 어기면 `null` — 보내지 않는다(제출 때 칸에 오류를 표시한다).
 * ⚠ 지어 고치지 않는다(`'4.5'` 를 `4` 로 깎지 않는다) — 사람이 적은 값과 다른 신고가 된다.
 */
export function loadConfirmReport(form: LoadConfirmForm): LoadConfirmReport | null {
  if (chambersInvalid(form.chambers)) return null
  const chambers = form.chambers.trim()
  return chambers === '' ? {} : { loadedChambers: Number(chambers) }
}
